import type { NotificationResponse } from "@/api";

const str = (v: unknown) => (typeof v === "string" && v ? v : undefined);

/**
 * Where clicking a notification goes in web/, from its type and metadata
 * (keys the backend has always written, so older notifications link too).
 * Null when web/ has no page for it yet (tasks, brainstorms, deep research).
 */
export function notificationHref(n: Pick<NotificationResponse, "type" | "metadata">): string | null {
  const m = n.metadata ?? {};
  switch (n.type) {
    case "flow_completed":
    case "flow_failed":
    case "flow_paused":
    case "scheduled_flow_triggered": {
      const flow = str(m.flow_uuid);
      const run = str(m.flow_run_uuid);
      if (flow && run) return `/build/workflows/${flow}/runs/${run}`;
      return flow ? `/build/workflows/${flow}` : null;
    }
    case "chat_shared": {
      const session = str(m.session_uuid);
      return session ? `/chat/${session}` : null;
    }
    case "data_sync_completed":
    case "data_sync_failed": {
      const collection = str(m.collection_uuid);
      return collection ? `/build/data-sources/${collection}` : null;
    }
    default:
      return null;
  }
}
